import State from '@/store/models/user/state';

const loggedInUserProfile = state => state.loggedInUserProfile;

const islandProgressionList = state => state.islandProgressionList;

const islandProgressionItem = state => state.islandProgressionItem;

const userCountry = state => state.userCountry;

const friendLists = state => state.friendLists;

const hasToken = ({ apiToken }) => apiToken !== undefined && apiToken !== null && apiToken !== '' && apiToken !== ' ';

const userState = (state) => {
  // TODO: keep eyes on this solution.
  if (state.loggedInUserProfile.user.state) {
    const userStateObj = new State();
    userStateObj.map(state.loggedInUserProfile.user.state);
    return userStateObj;
  }
  return undefined;
};

const isTimerAvailable = (state) => {
  const user = state.loggedInUserProfile.user;
  return !!(user && user.abInfo && user.abInfo.lessonTimerStatistics && user.state.payment.status == false);
};

const hasTimerUserMinutes = (state) => {
  const user = state.loggedInUserProfile.user;
  if (isTimerAvailable(state)) {
    return user.abInfo.lessonTimerStatistics.timerAvailableTime > 0;
  }
  return false;
};

const getUserTimer = (state) => {
  const user = state.loggedInUserProfile.user;
  if (user && user.abInfo && user.abInfo.lessonTimerStatistics) {
    return user.abInfo.lessonTimerStatistics;
  }
  return undefined;
};

const getApiToken = (state) => {
  let apiToken = window.$cookies.get('api-token');
  if (!apiToken || apiToken === 'undefined') {
    apiToken = state.loggedInUserProfile.apiToken;
  }
  return apiToken;
};

const isKretaUser = state => !!state.loggedInUserProfile.user.isDktMember;

const isKHUser = state => !!state.loggedInUserProfile.user.isKozigMember;

const isNeptunUser = state => !!state.loggedInUserProfile.user.isNeptunMember;

const getUserSocialState = (state) => {
  if (!state.loggedInUserProfile.user.token) {
    return undefined;
  }
  // return state.loggedInUserProfile.user.facebookId;
  if (state.loggedInUserProfile.user.facebookId != null) {
    return 'facebook';
  }
  if (state.loggedInUserProfile.user.googlePlusId != null) {
    return 'google';
  }
  if (state.loggedInUserProfile.user.appleId != null) {
    return 'apple';
  }
  if (state.loggedInUserProfile.user.isDktMember == true) {
    return 'dkt';
  }
  return 'traveller';
};

const getUserAfterCollision = state => state.userAfterCollision;

const getIdpToken = state => state.loggedInUserProfile.idpToken;

export default {
  loggedInUserProfile,
  islandProgressionList,
  islandProgressionItem,
  userCountry,
  friendLists,
  userState,
  getUserTimer,
  isTimerAvailable,
  hasTimerUserMinutes,
  isKretaUser,
  getApiToken,
  getUserSocialState,
  hasToken,
  getUserAfterCollision,
  isKHUser,
  isNeptunUser,
  getIdpToken,
};
